module.exports = __webpack_public_path__ + "static/img/course_move.2835ee99.gif";